import React, {useEffect, useRef, useState} from "react"
import { Link } from "gatsby"
import logoSVG from "../../../assets/img/dei_logo.svg";
import BurgerButton from "./burger-button/burger-button.component";
import HeaderCollapse from "./header-collapse.component";

import './header.styles.scss'
import GlobalNotification from "../global-notification/global-notification.component"

const HeaderComponent = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const headerRef = useRef(null);

    const scrollHandler = ()=>{
        const wrapper = document.querySelector("#gatsby-focus-wrapper");
        if(wrapper.scrollTop > 0){
            if(headerRef?.current){
                headerRef.current?.classList.add("fixed");
                headerRef.current?.classList.remove("absolute");
            }
        } else {
            headerRef.current?.classList.remove("fixed");
            headerRef.current?.classList.add("absolute");
        }
    }
    const menuToggle = (state)=>{
        if(state){
            document.body.classList.add('overflow-hidden')
            headerRef.current?.classList.add("menu-open");
        } else {
            document.body.classList.remove('overflow-hidden')
            headerRef.current?.classList.remove("menu-open");
        }
        setMenuOpen(state);

    }

    useEffect(()=>{
        const wrapper = document.querySelector("#gatsby-focus-wrapper");
        menuToggle(menuOpen);
        scrollHandler();
        wrapper?.addEventListener('scroll', scrollHandler)
        return ()=>{
            wrapper?.removeEventListener('scroll', scrollHandler)
        }
    },[])

    return(
        <>
            <header ref={headerRef} className="text-sm md:text-base absolute top-0 w-full with-notification">
                {/*<GlobalNotification> Τα προκρινόμενα 32 έργα και οι νικητές θα ανακοινωθούν σύντομα. </GlobalNotification>*/}
                <div className="container">
                    <nav className="flex flex flex-row items-center justify-between relative">
                        <Link className="inline-block py-2" to="/">
                            <img width="60" height="60" src={logoSVG} alt="ΔΕΗ"/>
                            <div className="sr-only">Αρχική</div>
                        </Link>
                        <HeaderCollapse isOpen={menuOpen} menuToggle={menuToggle} />
                        <BurgerButton onClick={()=>menuToggle(!menuOpen)} isOpen={menuOpen} className="xl:hidden"/>
                    </nav>
                </div>
            </header>
        </>
    )
}


export default HeaderComponent
